import Vue from 'vue'
import Keycloak from 'keycloak-js'
import Config from '@/config'

const options = {
  url: Config.KEYCLOAK_URL,
  realm: Config.KEYCLOAK_REALM,
  clientId: Config.KEYCLOAK_CLIENT_ID,
}

const _keycloak = new Keycloak(options)

const Plugin = {
  install(Vue) {
    Vue.$keycloak = _keycloak
  },
}

Plugin.install = (Vue) => {
  Vue.$keycloak = _keycloak
  Object.defineProperties(Vue.prototype, {
    $keycloak: {
      get() {
        return _keycloak
      },
    },
  })
}

Vue.use(Plugin)

export default Plugin
